import { Injectable } from '@angular/core';
import { ApiConfig } from '../config/apiConfig';
import { HttpClient } from '@angular/common/http';
import { ConfService } from 'src/conf.service';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FavoriteService {
  private rootUrl: string;
  private favouritesAPIUrl;

  constructor(private http: HttpClient) { 
    this.rootUrl = ConfService.conf.environment.apiRootUrl;
    this.favouritesAPIUrl = ApiConfig.FavouritesApiConfig;
  }

  addFavoriteList(favObj: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.favouritesAPIUrl.addFavoriteList}`, favObj
    
   
    
    )
      .pipe(
        tap(() => {
          //
        })
      );
  }

  addFavoriteListPart(favObj: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.favouritesAPIUrl.addFavoriteListPart}`, favObj)
      .pipe(
        tap(() => {
          //
        })
      );
  }

  updateFavoriteList(favObj: any): Observable<any> {
     
    return this.http.post(`${this.rootUrl}${this.favouritesAPIUrl.updateFavoriteList}`, favObj
   
    
    )
      .pipe(
        tap(() => {
          //
        })
      );
  }

  updateFavoriteListPart(favObj: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.favouritesAPIUrl.updateFavoriteListPart}`, favObj
    
    
    )
      .pipe(
        tap(() => {
          //
        })
      );
  }

  updateFavoriteListTestEquip(favObj: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.favouritesAPIUrl.updateFavoriteListTestEquip}`, favObj
    
    
    
    )
      .pipe(
        tap(() => {
          //
        })
      );
  }

  addFavoriteListTestEquip(favObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.favouritesAPIUrl.addFavoriteListTestEquip}`, favObj)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  
  deleteFavoriteList(favObj: any): Observable<any> {
   
    return this.http.post(`${this.rootUrl}${this.favouritesAPIUrl.deleteFavoriteList}`, favObj
    
    
    
    )
      .pipe(
        tap(() => {
          //
        })
      );
  }

  deleteFavoriteListPart(favObj: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.favouritesAPIUrl.deleteFavoriteListPart}`, favObj
    
    

    )
      .pipe(
        tap(() => {
          //
        })
      );
  }

  deleteFavoriteListTestEquip(favObj: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.favouritesAPIUrl.deleteFavoriteListTestEquip}`, favObj
    
    
    )
      .pipe(
        tap(() => {
          //
        })
      );
  }

 deleteTestFavoriteList(favObj: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.favouritesAPIUrl.deleteTestFavoriteList}`, favObj
    
    
    )
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getFavoriteList(favObj: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.favouritesAPIUrl.getFavoriteList}`, favObj
        
    )
      .pipe(
        tap(() => {
          //
        })
      );
  }

  getFavoriteListSync(favObj: any): Promise<any> {
    return this.http.post(`${this.rootUrl}${this.favouritesAPIUrl.getFavoriteList}`, favObj
        
    ).toPromise()
  }

  
  getFavoriteListParts(favObj: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.favouritesAPIUrl.getFavoriteListParts}`, favObj
    
    
    )
      .pipe(
        tap(() => {
          //
        })
      );
  }

  getFavoriteListTestEquip(favObj: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.favouritesAPIUrl.getFavoriteListTestEquip}`, favObj
     
    )
      .pipe(
        tap(() => {
          //
        })
      );
  }

}
